// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-name[data-v-0bc5bbca]{position:absolute;top:2.5rem;left:1rem;width:80%}", ""]);
// Exports
module.exports = exports;
